import React, { useState } from "react";
import ThemeSection from "../ThemeSection/ThemeSection";
import { loadMoreTexts, getLocalItems } from "../../assets/Helpers";
import LoadMoreButton from "../../components/LoadMoreButton/LoadMoreButton";
import ProductItem from "./ProductItem/ProductItem";
import ProductsLoader from "./ProductsContainer/ProductsLoader";
import ProductsContainer from "./ProductsContainer/ProductsContainer";
import ProductTitleLoader from "./ProductSectionTitle/ProductTitleLoader";
import ProductSectionTitle from "./ProductSectionTitle/ProductSectionTitle";
import { useQuery } from "@apollo/react-hooks";
import { GET_PRODUCTS_BY_SLUG } from "../../queries/productsQuery";
import "./ProductSection.scss";

const ProductSection = (props) => {
  const [buttonText, setButtonText] = useState(loadMoreTexts.default);
  const { data, loading, error, fetchMore } = useQuery(GET_PRODUCTS_BY_SLUG, {
    variables: { slug: props.slug, limit: props.limit || 10 },
  });

  const localItems = getLocalItems();
  const localFavorites = localItems ? JSON.parse(localItems).favorites : [];

  if (loading) return <ThemeSection><ProductTitleLoader /><ProductsLoader total={props.limit} /></ThemeSection>;
  if (error) return <ThemeSection><p>Ju lutemi provoni përseri.</p></ThemeSection>;

  const products = data?.products?.nodes || [];
  const category = data?.productCategories?.nodes?.[0];
  const pageInfo = data?.products?.pageInfo;
  const isArchive = props.isArchive;

  const handleClick = async () => {
    setButtonText(loadMoreTexts.loading);
    await fetchMore({
      variables: { slug: props.slug, limit: props.limit || 10, after: pageInfo?.endCursor },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;
        return {
          ...fetchMoreResult,
          products: {
            ...fetchMoreResult.products,
            nodes: [...prev.products.nodes, ...fetchMoreResult.products.nodes],
          },
        };
      },
    });
    setButtonText(loadMoreTexts.default);
  };

  return (
    <>
      <ThemeSection>
        <ProductSectionTitle isArchive={isArchive} slug={props.slug} title={props.customTitle || category?.name} />
        <ProductsContainer>
          {products.map((product) => (
            <ProductItem key={product.id} isFavorite={localFavorites.includes(product.productId)} isFavorites={props.isFavorites} {...product} />
          ))}
        </ProductsContainer>
      </ThemeSection>
      {isArchive && pageInfo?.hasNextPage && <LoadMoreButton title={buttonText} onClick={handleClick} />}
    </>
  );
};

export default ProductSection;
